import { ThemeUIStyleObject } from 'theme-ui';

export const clickable: ThemeUIStyleObject = {
    cursor: 'pointer',
    '&[disabled]': {
        pointerEvents: 'none'
    }
};
